export const generateRandomKeys = () => {
    return new Date().getMilliseconds() * new Date().getMilliseconds()*2 * Math.random()+1;
};
